export const translateMixin = {
    data() {
        return {
            translations: {
                login: {
                    RU: 'Войти',
                    EN: 'Login',
                    KZ: 'Войти',
                    BY: 'Увайсці',
                    AM: 'Ներս մտնել',
                    TR: 'İçeri gel',
                    DE: 'Betreten'
                },
                registration: {
                    RU: 'Регистрация',
                    EN: 'Registration',
                    KZ: 'Регистрация',
                    BY: 'Рэгістрацыя',
                    AM: 'Գրանցում',
                    TR: 'Kayıt',
                    DE: 'Anmeldung'
                },
                search_wiki_articles: {
                    RU: 'Поиск по статьям WiKi',
                    EN: 'Search WiKi articles',
                    KZ: 'Поиск по статьям WiKi',
                    BY: 'Пошук па артыкулах WiKi',
                    AM: 'Որոնել WiKi հոդվածներ',
                    TR: 'Wiki makalelerini arayın',
                    DE: 'Durchsuchen Sie WiKi-Artikel'
                },
                article_not_available: {
                    RU: 'Статья не доступна',
                    EN: 'Article not available',
                    KZ: 'Статья не доступна',
                    BY: 'Артыкул не даступны',
                    AM: 'Հոդվածը հասանելի չէ',
                    TR: 'Makale mevcut değil',
                    DE: 'Artikel nicht verfügbar'
                },
                all_results: {
                    RU: 'Все результаты',
                    EN: 'All results',
                    KZ: 'Все результаты',
                    BY: 'Усе вынікі',
                    AM: 'Բոլոր արդյունքները',
                    TR: 'Tüm sonuçlar',
                    DE: 'Alle Ergebnisse'
                },
                last_updated: {
                    RU: 'Последний раз обновлено',
                    EN: 'Last updated',
                    KZ: 'Последний раз обновлено',
                    BY: 'Апошні раз абноўлена',
                    AM: 'Վերջին անգամ թարմացվել է',
                    TR: 'Son güncelleme',
                    DE: 'Letzte Aktualisierung'
                },
                created: {
                    RU: 'Создана',
                    EN: 'Created',
                    KZ: 'Создана',
                    BY: 'Створана',
                    AM: 'Ստեղծվել է',
                    TR: 'Oluşturuldu',
                    DE: 'Erstellt'
                },
                sub_articles: {
                    RU: 'Подстатьи',
                    EN: 'Sub-articles',
                    KZ: 'Подстатьи',
                    BY: 'Падстацьці',
                    AM: 'Ենթահոդվածներ',
                    TR: 'Alt makaleler',
                    DE: 'Unterartikel'
                },
                nothing_found: {
                    RU: 'Ничего не найдено',
                    EN: 'Nothing found',
                    KZ: 'Ничего не найдено',
                    BY: 'Нічога не знойдзена',
                    AM: 'Ոչինչ չի գտնվել',
                    TR: 'Hiçbirşey Bulunamadı',
                    DE: 'Nichts gefunden'
                },
                wiki_is_an_integral_part: {
                    RU: `Wiki является неотъемлемой частью программы, поскольку она позволяет пользователям легко и быстро находить необходимую информацию, а также обмениваться ею. Она обеспечивает централизованное хранение данных, что упрощает процесс поиска и доступа к ним.`,
                    EN: `Wiki is an integral part of the program as it allows ENers to quickly and easily find and share the information they need. It provides centralized storage of data, which simplifies the process of searching and accessing it.`,
                    KZ: `Wiki является неотъемлемой частью программы, поскольку она позволяет пользователям легко и быстро находить необходимую информацию, а также обмениваться ею. Она обеспечивает централизованное хранение данных, что упрощает процесс поиска и доступа к ним.`,
                    BY: `Wiki з'яўляецца неад'емнай часткай праграмы, паколькі яна дазваляе карыстачам лёгка і хутка знаходзіць неабходную інфармацыю, а таксама абменьвацца ёю. Яна забяспечвае цэнтралізаванае захоўванне даных, што спрашчае працэс пошуку і доступу да іх.`,
                    AM: `Wiki-ն ծրագրի անբաժանելի մասն է, քանի որ այն թույլ է տալիս օգտվողներին արագ և հեշտությամբ գտնել և կիսվել իրենց անհրաժեշտ տեղեկատվությունը: Այն ապահովում է տվյալների կենտրոնացված պահպանում, ինչը հեշտացնում է դրանց որոնման և մուտք գործելու գործընթացը:`,
                    TR: `Wiki, kullanıcıların ihtiyaç duydukları bilgileri hızlı ve kolay bir şekilde bulup paylaşmalarına olanak tanıdığı için programın ayrılmaz bir parçasıdır. Verilerin merkezi olarak depolanmasını sağlar, bu da arama ve erişme sürecini basitleştirir.`,
                    DE: `Wiki ist ein integraler Bestandteil des Programms, da es Benutzern ermöglicht, die benötigten Informationen schnell und einfach zu finden und zu teilen. Es bietet eine zentrale Speicherung von Daten, was die Suche und den Zugriff darauf vereinfacht.`
                },
                wiki_is_the_companys_knowledge: {
                    RU: `WiKi - это база знаний компании, в которой мы собираем важные статьи для пользователей.`,
                    EN: `WiKi is the company's knowledge base in which we collect important articles for ENers.`,
                    KZ: `WiKi - это база знаний компании, в которой мы собираем важные статьи для пользователей.`,
                    BY: `WiKi – гэта база ведаў кампаніі, у якой мы збіраем важныя артыкулы для карыстальнікаў.`,
                    AM: `WiKi-ն ընկերության գիտելիքների բազան է, որտեղ մենք կարևոր հոդվածներ ենք հավաքում օգտատերերի համար:`,
                    TR: `WiKi, kullanıcılar için önemli makaleleri topladığımız şirketin bilgi tabanıdır.`,
                    DE: `WiKi ist die Wissensdatenbank des Unternehmens, in der wir wichtige Artikel für Benutzer sammeln.`
                },
                updated_title: {
                    RU: `Обновлено: 20 марта 2020г.`,
                    EN: `Updated: March 20, 2020`,
                    KZ: 'Обновлено: 20 марта 2020г.',
                    BY: 'Абноўлена: 20 сакавіка 2020г.',
                    AM: 'Թարմացվել է՝ 20 մարտի, 2020 թ',
                    TR: 'Güncelleme: 20 Mart 2020',
                    DE: 'Aktualisiert: 20. März 2020'
                },
                tg_channel: {
                    RU: 'Телеграм канал',
                    EN: 'Telegram channel',
                    KZ: 'Телеграм канал',
                    BY: 'Тэлеграм канал',
                    AM: 'Telegram ալիք',
                    TR: 'Telgraf kanalı',
                    DE: 'Telegram-Kanal'
                },
                program_updates: {
                    RU: 'Обновления программы',
                    EN: 'Program updates',
                    KZ: 'Обновления программы',
                    BY: 'Абнаўленні праграмы',
                    AM: 'Ծրագրի թարմացումներ',
                    TR: 'Program güncellemeleri',
                    DE: 'Programmaktualisierungen'
                },
                youtube_channel: {
                    RU: 'Youtube канал',
                    EN: 'Youtube channel',
                    KZ: 'Youtube канал',
                    BY: 'Youtube канал',
                    AM: 'Youtube ալիք',
                    TR: 'Youtube kanalı',
                    DE: 'Youtube Kanal'
                },
                ios_app: {
                    RU: 'Приложение iOS',
                    EN: 'iOS app',
                    KZ: 'Приложение iOS',
                    BY: 'Дадатак iOS',
                    AM: 'iOS հավելված',
                    TR: 'iOS uygulaması',
                    DE: 'iOS-App'
                },
                technical_support: {
                    RU: 'Техническая поддержка',
                    EN: 'Technical support',
                    KZ: 'Техническая поддержка',
                    BY: 'Тэхнічная падтрымка',
                    AM: 'Տեխնիկական աջակցություն',
                    TR: 'Teknik Destek',
                    DE: 'Technische Unterstützung'
                },
                android_app: {
                    RU: 'Приложение Android',
                    EN: 'Android application',
                    KZ: 'Приложение Android',
                    BY: 'Прыкладанне Android',
                    AM: 'Android հավելված',
                    TR: 'Android uygulama',
                    DE: 'Android-Anwendung'
                },
                copied: {
                    RU: 'Скопировано',
                    EN: 'Copied',
                    KZ: 'Скопировано',
                    BY: 'Скапіравана',
                    AM: 'Պատճենվել է',
                    TR: 'Kopyalandı',
                    DE: 'Kopiert'
                }
            }
        }
    },
    methods: {
        getTranslate(slug) {
            if(this.translations && slug in this.translations) {
                return this.translations[slug][this.workflowData.languageSystem]
            }
            return this.translations[slug][this.workflowData.languageSystem]
        }
    }
}